import PropTypes from 'prop-types';

export const apolloSharedPropTypes = {
	error: PropTypes.object,
	fetchMore: PropTypes.func,
	loading: PropTypes.bool,
	networkStatus: PropTypes.number,
	refetch: PropTypes.func,
	startPolling: PropTypes.func,
	stopPolling: PropTypes.func,
	subscribeToMore: PropTypes.func,
	updateQuery: PropTypes.func,
	variables: PropTypes.object,
};
